<template>
  <section class="home-section home-logistica mb-3 mb-md-4">
    <div class="container">
      <div class="section-head mb-3 mb-md-5">
        <div class="service-head-bg">
          <img
            src="@/assets/images/service-head-bg-2.jpg"
            alt
            class="img-fluid"
          />
        </div>
        <div class="sec-header">
          <h1 class="title"><span>2.</span>Logística</h1>
          <h2 class="sec-subtitle">Servicios de logística integrada.</h2>

          <div class="section-head-action">
            <router-link
              class="btn btn-outline-light rounded-0 font-weight-bold"
              to="/servicios"
            >
              <span>+</span> Info
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="sec-content">
        <div class="row mb-3 mb-md-4">
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">¿QUÉ ES LA LOGÍSTICA?</h2>
            <h3 class="sec-desc-subtitle">Implementacion y control.</h3>
            <p class="sec-desc-cont">
              Es una parte del proceso de la cadena de suministros, que planea
              implementa y controla el eficiente y efectivo flujo y
              almacenamiento, hacia delante y en reversa de bienes, servicios e
              información relacionada del punto de origen al punto de consumo,
              con el propósito de satisfacer los requerimientos del cliente.
            </p>
          </div>
          <div class="col-md-4 sec-desc">
            <div class="sec-desc-img">
              <img
                src="@/assets/images/logistica-grafico.svg"
                alt="Gráfico de Logística WMS"
                class="img-fluid"
              />
            </div>
          </div>
          <div class="col-md-4 sec-desc mb-3">
            <h2 class="sec-desc-title">Proceso de Almacen</h2>
            <h3 class="sec-desc-subtitle">Planificación y organización.</h3>
            <p class="sec-desc-cont">
              El mapa de proceso de la gestión de almacenes se compone de dos
              ejes transversales que representan los procesos principales -
              Planificación y Organización y Manejo de la información - y tres
              subprocesos que componen la gestión de actividades y que abarca la
              recepción, el almacén y el movimiento.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeLogistica',
}
</script>

<style lang="scss" scoped>
.home-logistica {
  .sec-desc-title {
    margin-bottom: 0;
    font-size: 2.7rem;
    line-height: 2.7rem;
  }
  .sec-desc-subtitle {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 200;
    margin-bottom: 1.5rem;
  }
}
</style>
